import { render } from "./Delivery.vue?vue&type=template&id=38d60910&scoped=true&ts=true"
import script from "./Delivery.vue?vue&type=script&lang=ts"
export * from "./Delivery.vue?vue&type=script&lang=ts"

import "./Delivery.vue?vue&type=style&index=0&id=38d60910&scoped=true&lang=scss"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d60910"]])

export default __exports__